<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { xssColors } from '@/Common/constants';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // execution.consistency of a report: training days on target, close and missed (the planner's classification).
  export let consistency: any;
  export let inProgress = false;

  const R = 42;
  const C = 2 * Math.PI * R;
  $: total = consistency?.training_days ?? 0;
  $: parts = [
    { key: 'on_target', label: $_('report.consistency.on_target'), color: xssColors.deviationGood, n: consistency?.on_target ?? 0 },
    { key: 'close', label: $_('report.consistency.close'), color: xssColors.deviationWarn, n: consistency?.close ?? 0 },
    { key: 'missed', label: $_('report.consistency.far_off'), color: xssColors.deviationAlert, n: consistency?.missed ?? 0 },
  ];
  // Each part is an arc: its length and where it starts, clockwise from the top.
  $: arcs = parts.map((p, i) => ({ ...p, length: total ? (p.n / total) * C : 0, offset: parts.slice(0, i).reduce((s, q) => s + (total ? (q.n / total) * C : 0), 0) }));
  const pct = (n: number) => (total ? Math.round((100 * n) / total) : 0);
</script>

{#if total > 0}
  <div class="flex items-center gap-4">
    <div class="relative w-[104px] h-[104px] shrink-0">
      <svg viewBox="0 0 100 100" class="w-full h-full -rotate-90" role="img" aria-label={$_('report.consistency.aria', { values: { percent: consistency.percent_on_or_near_target } })}>
        <circle cx="50" cy="50" r={R} fill="none" stroke="#E5E7EB" stroke-width="10" />
        {#each arcs as a}
          {#if a.length > 0}<circle cx="50" cy="50" r={R} fill="none" stroke={a.color} stroke-width="10" stroke-dasharray="{a.length} {C - a.length}" stroke-dashoffset={-a.offset} />{/if}
        {/each}
      </svg>
      <div class="absolute inset-0 flex items-center justify-center text-xl font-semibold">{consistency.percent_on_or_near_target}%</div>
    </div>
    <div class="text-sm min-w-0 flex-1">
      <div class="text-zinc-500 mb-1">{$_('report.consistency.on_or_near')}<br />({$_(inProgress ? 'report.consistency.of_so_far' : 'report.consistency.of', { values: { n: consistency.on_or_near_target, total } })})</div>
      {#each parts as p}
        <div class="flex items-center gap-2 tabular-nums"><span class="inline-block w-2.5 h-2.5 rounded-full" style="background:{p.color}" /><span class="whitespace-nowrap">{p.n} {p.label.toLowerCase()}</span><span class="text-zinc-500 ml-auto pl-3">{pct(p.n)}%</span></div>
      {/each}
    </div>
  </div>
  <p class="mt-3 text-xs text-zinc-500">{$_('report.consistency.how_judged')}</p>
{:else}
  <p class="text-sm text-zinc-500">{$_('report.consistency.none')}</p>
{/if}
